export default __webpack_public_path__ + "static/media/JS4E.877c351d.jpg";